var callbacks = new WeakMap();
function getListeners(target) {
    var listeners = callbacks.get(target);
    if (!listeners) {
        listeners = new Set();
        callbacks.set(target, listeners);
    }
    return listeners;
}
var queue = new Set();
var run = function (fn) { return fn(); };
var ɵ0 = run;
function execute() {
    try {
        queue.forEach(function (target) {
            try {
                getListeners(target).forEach(run);
            }
            finally {
                queue.delete(target);
            }
        });
    }
    catch (err) {
        if (queue.size) {
            execute();
        }
        throw err;
    }
}
export function dispatch(target) {
    if (!queue.size) {
        requestAnimationFrame(execute);
    }
    queue.add(target);
}
export function subscribe(target, cb) {
    getListeners(target).add(cb);
    dispatch(target);
    return function () { return getListeners(target).delete(cb); };
}
export { ɵ0 };
//# sourceMappingURL=emitter.js.map